import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { Toaster } from './components';
import { useAppResources } from './hooks';
import { Router } from './pages/router.tsx';
import { AuthProvider } from './services/auth/auth.context.tsx';

if (!import.meta.env.DEV) {
  Sentry.init({
    // Sentry DSN is not a secret, cf. https://docs.sentry.io/concepts/key-terms/dsn-explainer/
    dsn: 'https://ea0f19249d8b956f3ed94e54f5cccb60@o4509393945362432.ingest.de.sentry.io/4509440403177553',
    environment: import.meta.env.MODE,
    dataCollection: {
      userInfo: true,
      cookies: true,
      httpHeaders: {
        request: true,
        response: true,
      },
      httpBodies: [
        'incomingRequest',
        'outgoingRequest',
        'incomingResponse',
        'outgoingResponse',
      ],
      urlQueryParams: true,
      databaseQueryData: true,
      stackFrameVariables: true,
      frameContextLines: 20,
    },
    integrations: [],
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

function App() {
  const areAppResourcesLoaded = useAppResources();

  return areAppResourcesLoaded ? (
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <Toaster />
        <Router />
      </QueryClientProvider>
    </AuthProvider>
  ) : (
    <div />
  );
}

export default App;
